const size = {
    mobileS: '320px',
    threehundredandsixty: '361px',
    mobileM: '375px',
    mobileL: '425px',
    mobilepoc: '520px',
    tablet: '768px',
    laptop: '1024px',
    laptopL: '1440px',
    desktop: '2560px'
  }


export const device = {
    mobileS: `(min-width: ${size.mobileS})`,
    threehundredandsixty:  `(min-width: ${size.threehundredandsixty})`,
    mobileM: `(min-width: ${size.mobileM})`,
    mobileL: `(min-width: ${size.mobileL})`,
    mobilepoc:  `(min-width: ${size.mobilepoc})`,
    tablet: `(min-width: ${size.tablet})`,
    laptop: `(min-width: ${size.laptop})`,
    laptopL: `(min-width: ${size.laptopL})`,
    desktop: `(min-width: ${size.desktop})`,
    desktopL: `(min-width: ${size.desktop})`
  };